import { motion } from 'framer-motion';
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const brands = [
  {
    logo: "https://app.thenewscc.com.br/rising.webp",
    description: "reflexões e experiências que despertam o seu melhor. para uma mente saudável",
    href: "https://rising.waffle.com.br",
    schedule: "terça e quinta, às 05:15",
  },
  {
    logo: "https://app.thenewscc.com.br/goget.webp",
    description: "seu novo guia favorito! dicas de restaurantes, bares, exposições, filmes...",
    href: "https://goget.waffle.com.br",
    schedule: "toda quinta às 11:11",
  },
  {
    logo: "https://app.thenewscc.com.br/thejobs.webp",
    description: "um one-on-one com uma curadoria de conteúdos sobre carreira",
    href: "https://thejobs.waffle.com.br",
    schedule: "toda segunda, às 18:18",
  },
  {
    logo: "https://app.thenewscc.com.br/thenews.webp",
    description: "para começar o seu dia bem e informado: mais inteligente em 5 minutos",
    href: "https://thenews.waffle.com.br",
    schedule: "sempre às 06:06 manhã",
  },
  {
    logo: "https://app.thenewscc.com.br/thebizness.webp",
    description: "análises e insights sobre o mundo dos negócios",
    href: "https://thebizness.waffle.com.br",
    schedule: "terça e quinta, às 13:13",
  },
  {
    logo: "https://app.thenewscc.com.br/thestories.webp",
    description: "histórias de amor contadas em forma de texto",
    href: "https://thestories.waffle.com.br",
    schedule: "todo domingo, às 08:08",
  },
  {
    logo: "https://app.thenewscc.com.br/thechamps.webp",
    description: "análises, notícias e highlight do seu esporte favorito.",
    href: "https://thechamps.waffle.com.br",
    schedule: "seg / qua / sex às 09:09",
  },
  {
    logo: "https://app.thenewscc.com.br/healthtimes.webp",
    description: "tudo que você precisa saber sobre saúde de forma simples, rápida e interessante",
    href: "https://healthtimes.waffle.com.br",
    schedule: "segunda e sextas às 06:30",
  },
];

export const RecommendationSlider = () => {
  return (
    <div className="mb-2 py-6">
      <div className="container mx-auto px-4 border-t border-gray-200 dark:border-gray-700">
        <div className="flex items-center gap-4 mb-4 mt-6">
          <img src="https://app.thenewscc.com.br//favicon.png" alt="Mascote" className="w-16 h-16" />
          <div>
            <h2 className="text-sm text-gray-600 dark:text-gray-400">waffle | criando marcas que você gosta de consumir</h2>
            <p className="text-2xl font-bold dark:text-white">
              junte-se a mais de 2 milhões de pessoas e receba nossos conteúdos com base no que mais se adequar a você
            </p>
          </div>
        </div>

        <motion.div className="overflow-x-auto flex gap-8 mt-8 pb-4 cursor-grab">
          {brands.map((brand, index) => (
            <Card
              key={index}
              className="min-w-[300px] bg-white dark:bg-gray-800 border-none shadow-sm p-8"
            >
              <img src={brand.logo} alt="" className="h-8 mb-8" />
              <p className="text-gray-700 dark:text-gray-300 mb-8 text-base leading-relaxed">
                {brand.description}
              </p>
              <Button 
                variant="outline"
                className="w-full mb-8 bg-white dark:bg-gray-700 border-[1.5px] border-black dark:border-gray-600 hover:bg-gray-50/50 text-black dark:text-white font-medium"
              >
                inscreva-se
              </Button>
              <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
                <svg 
                  className="w-4 h-4 mr-2 text-[#FF69B4]" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
                  />
                </svg>
                <span className="text-xs">{brand.schedule}</span>
              </div>
            </Card>
          ))}
        </motion.div>
      </div>
    </div>
  );
}; 